import { lazy } from "react";
import { loadI18n } from "./loadI18n";
import { loadAuthHttp } from "../app/authHttpLoader";

// React.lazy for route-level code splitting, with one safety net.
//
// A deploy replaces the hashed chunk files. A tab that was opened before the deploy
// still points at the OLD chunk names; the first navigation in that tab then fails with
// "Loading chunk ... failed" and the page goes blank. Reloading once fetches the new
// entry file (index.html is served with no-cache) and the new chunk names. The
// timestamp in sessionStorage stops a real outage from turning into a reload loop.

const RELOAD_KEY = "chunk_reload_at";
const RELOAD_COOLDOWN_MS = 10000;

export function lazyRetry(factory) {
  return lazy(() =>
    factory().catch((error) => {
      try {
        const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last > RELOAD_COOLDOWN_MS) {
          window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          return new Promise(() => {}); // never settles: the page is reloading
        }
      } catch (storageError) {
        // storage blocked: fall through and surface the original error
      }
      throw error;
    })
  );
}

// Same, for a page that uses translations (useTranslation or i18n) or the API through axios: neither the translation
// stack (loadI18n.js) nor axios with its auth handling (app/authHttpLoader.js) is part of the entry bundle any more,
// so they load with the page chunk and the page renders once all are in.
export function lazyWithI18n(factory) {
  return lazyRetry(() => Promise.all([factory(), loadI18n(), loadAuthHttp()]).then(([module]) => module));
}
